import React, { useState, useEffect } from 'react';
import styles from './FusionOptionItem.module.scss';
import { ReactComponent as TowerLogo } from '../../../assets/imgs/logo-tower.svg';
import IconTimer from '../../../assets/imgs/fusion/icon-timer.png';
import { countdownTimer } from '../../../services/TimerService';
import moment from 'moment';
import IconItemQty from '../../../assets/icons/store/icon_item_qty_logo.png';

const FusionOptionItem = (props) => {
    const {
        outputItemName,
        outputItemType,
        outputItemImage,
        towerCost,
        inputItems,
        selectedItem,
        ownedCount,
        vipPoints,
        handleItemSelect,
        limitReached,
        limitEndDate,
    } = props;
    const [countdownTime, setCountdownTime] = useState(null);

    useEffect(() => {
        if (limitEndDate && limitReached && !countdownTime) {
            let currentTimestamp = moment().utc();
            let endDateTime = new moment(limitEndDate);
            countdownTimer(endDateTime, setCountdownTime, currentTimestamp);
        }
    }, [limitEndDate, limitReached])
    
    return (
        <div className={`${styles.fusion_option_item} ${selectedItem === outputItemType ? styles.option_item_selected : ''}`} onClick={handleItemSelect}>
            <div className={`${styles.fusion_limit_message} ${limitReached ? styles.fusion_limit_reached : ''}`}>
                <img src={IconTimer} alt="timer" />
                <span>Limit reopen countdown:</span>
                <div className={styles.timer_text}>{countdownTime?.days}:{countdownTime?.hours}:{countdownTime?.minutes}</div>
            </div>
            <div className={styles.item_header}>
                <div className={styles.output_item_title}>{outputItemName}</div>
                <div className={styles.tower_cost}>
                    <div className={styles.tower_img}>
                        <TowerLogo />
                    </div>
                    <span>{parseInt(towerCost).toLocaleString()}</span>
                </div>
            </div>
            <div className={styles.horizontal_line}></div>
            <div className={styles.item_body}>
                <div className={styles.output_item}>
                    <div className={styles.output_item_img}>
                        <img src={outputItemImage} alt="output-item" />
                    </div>
                    {(ownedCount && ownedCount >= 0) ? <div>Owned: {ownedCount}</div> : ''}
                    {(vipPoints && vipPoints >= 0) ? <div className={styles.vip_points}>
                        <img src={IconItemQty} alt="vip-points" />
                        {vipPoints}
                    </div> : ''}
                </div>
                <div className={styles.input_items_container}>
                    <div className={styles.input_items_label}>Required Materials</div>
                    <div className={styles.input_items}>
                        {inputItems.map((item, index) => (
                            <div className={styles.input_item} key={index}>
                                <div className={styles.input_item_img}>
                                    <img src={item.image} alt="fusion-input-item" />
                                </div>
                                <div className={styles.input_item_count}>x{item.material_quantity}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export { FusionOptionItem };
